import React, { useState, useEffect, useContext, useCallback } from 'react';
import axios from 'axios';
import api from '../api';
// import '../index.css';
import './ListadoRenta.css';
import { debounce } from 'lodash';
import { UserContext } from '../context/UserContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faSync } from '@fortawesome/free-solid-svg-icons';
import { useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import ReactModal from 'react-modal';
import { toast } from 'sonner';
import { formatRut, normalizeRut } from '../utils/formatRut';

ReactModal.setAppElement('#root');

const ListadoRenta = () => {
    const { currentUser } = useContext(UserContext);
    const [rentas, setRentas] = useState([]);
    const [contadores, setContadores] = useState([]);
    const [years, setYears] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [search, setSearch] = useState('');
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [selectedContador, setSelectedContador] = useState('');
    const [filteredRentas, setFilteredRentas] = useState([]);
    const [editingValue, setEditingValue] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [selectedEstado, setSelectedEstado] = useState('');
    const [selectedDJ, setSelectedDJ] = useState(''); // Nuevo estado para filtro DJ
    const [estadosSII, setEstadosSII] = useState({}); // Estado para guardar estados SII por RUT
    const [siiModal, setSiiModal] = useState(null); // { nombre, rut, data } para el modal de detalle SII
    const [actualizandoSII, setActualizandoSII] = useState({}); // clienteId -> true cuando está actualizando
    const location = useLocation();
    const printRef = useRef();
    const [showCreateForm, setShowCreateForm] = useState(false);
    const [editingCliente, setEditingCliente] = useState(null);
    const [formData, setFormData] = useState({ nombre: '', rut: '', clave: '', banco: '', cuenta: '', iva: false, renta: false, arriendo: false });
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
const [newCliente, setNewCliente] = useState({
  nombre: '',
  rut: '',
  clave: '',
  banco: '',
  cuenta: '',
  iva: false,
  renta: true, // Por defecto activado, ya que estamos en renta
  arriendo: false
});


    const estados = ['pendiente', 'declarada', 'guardada', 'diferida', 'observada', 'No hacer', 'Pago Pendiente'];

    // Mapeo de estados SII a iconos
    const estadosSIIMap = {
        aceptada: { icon: '✅', title: 'Aceptada' },
        aceptada_con_devolucion: { icon: '💰', title: 'Aceptada con Devolución' },
        devolucion_en_proceso: { icon: '💸', title: 'Devolución en Proceso' },
        retenida: { icon: '🛑', title: 'Devolución Retenida' },
        observada: { icon: '🟡', title: 'Observada' },
        rechazada: { icon: '🔴', title: 'Rechazada' },
        recibida: { icon: '🟡', title: 'Recibida' },
        pago_pendiente: { icon: '⏳', title: 'Pago Pendiente' },
        no_declarada: { icon: '⚪', title: 'No Declarada' },
        sin_clave: { icon: '🔒', title: 'Sin Clave SII' },
        credencial_invalida: { icon: '🔑', title: 'Clave Incorrecta' },
        persona_fallecida: { icon: '🔑', title: 'Persona Fallecida' },
        rut_invalido: { icon: '🪪', title: 'RUT Inválido' },
        no_hacer: { icon: '⛔', title: 'No Hacer' },
        error: { icon: '❌', title: 'Error' }
    };

const estadosConfig = {
        pendiente: {
            color: 'bg-white',
            text: 'text-gray-700',
            border: 'border-gray-300',
            row: 'bg-white'
        },
        declarada: {
            color: 'bg-green-100',
            text: 'text-green-800',
            border: 'border-green-200',
            row: 'bg-green-100'
        },
        guardada: {
            color: 'bg-blue-100',
            text: 'text-blue-800',
            border: 'border-blue-200',
            row: 'bg-blue-100'
        },
        diferida: {
            color: 'bg-yellow-100',
            text: 'text-yellow-800',
            border: 'border-yellow-200',
            row: 'bg-yellow-100'
        },
        observada: {
            color: 'bg-orange-100',
            text: 'text-orange-800',
            border: 'border-orange-200',
            row: 'bg-orange-200'
        },
        'No hacer': {
            color: 'bg-red-200',
            text: 'text-red-800',
            border: 'border-red-800',
            row: 'bg-red-200'
        },
        'Pago Pendiente': {
            color: 'bg-purple-100',
            text: 'text-purple-800',
            border: 'border-purple-200',
            row: 'bg-purple-100'
        }
    };

    useEffect(() => {
        const fetchYears = async () => {
            try {
                const response = await api.get(`${process.env.REACT_APP_API_URL}/rentas/years`);
                if (response.data.length === 0) {
                    setYears([new Date().getFullYear()]); // Al menos mostrar el año actual
                } else {
                    setYears(response.data);
                }
            } catch (error) {
                console.error('Error al cargar años:', error);
                setYears([new Date().getFullYear()]);
            }
        };
        fetchYears();
    }, []);


    const handlePrint = useReactToPrint({
        content: () => printRef.current,
        documentTitle: `Listado_Renta_${selectedYear}`,
        removeAfterPrint: true,
        onBeforePrint: () => console.log("Preparando para imprimir..."),
        onAfterPrint: () => console.log("Impresión completada"),
    });


  // Función para crear nuevo cliente
  const handleCreateSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const response = await axios.post(`${process.env.REACT_APP_API_URL || ''}/listados`, newCliente);
      
      if (response.data) {
        Swal.fire({
          title: 'Cliente creado',
          text: `${newCliente.nombre} ha sido añadido a la base de datos. Para incluirlo en el listado de renta actual, use la función "Reprocesar Apertura".`,
          icon: 'success',
          confirmButtonText: 'Entendido'
        });
        
        // Limpiar el formulario y cerrarlo
        setNewCliente({
          nombre: '',
          rut: '',
          clave: '',
          banco: '',
          cuenta: '',
          iva: false,
          renta: true,
          arriendo: false
        });
        setShowCreateForm(false);
        fetchRentas(); // Refrescar lista aunque probablemente no haya cambios
      }
    } catch (error) {
      console.error("Error al crear cliente:", error);
      Swal.fire('Error', `No se pudo crear el cliente: ${error.response?.data?.message || error.message}`, 'error');
    } finally {
      setLoading(false);
    }
  };
  
  // Edición individual
  const handleEditClick = (renta) => {
    const cliente = renta.clienteId;
    setEditingCliente(cliente._id);
    setFormData({
      nombre: cliente.nombre || '',
      rut: cliente.rut || '',
      clave: cliente.clave || '',
      banco: cliente.banco || '',
      cuenta: cliente.cuenta || '',
      iva: cliente.iva || false,
      renta: cliente.renta || false,
      arriendo: cliente.arriendo || false
    });
    setIsEditModalOpen(true);
  };

  const handleEditChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === 'checkbox' ? checked : value });
  };

  const handleEditSave = async () => {
    try {
      await api.put(`/listados/${editingCliente}`, formData);
      Swal.fire('Éxito', 'Cliente actualizado exitosamente', 'success');
      closeModal();
      await fetchRentas();
    } catch (error) {
      console.error('Error al actualizar cliente:', error);
      Swal.fire('Error', 'No se pudo actualizar el cliente', 'error');
    }
  };

  const handleDelete = async (renta) => {
    const cliente = renta.clienteId;
    const { value: confirmed } = await Swal.fire({
      title: '¿Estás seguro?',
      html: `¿Deseas eliminar el cliente <strong>"${cliente.nombre}"</strong>?<br><br>Esto eliminará el cliente del sistema y todas sus rentas asociadas.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6'
    });

    if (confirmed) {
      try {
        await api.delete(`/listados/${cliente._id}`);
        Swal.fire('Eliminado', 'Cliente eliminado exitosamente', 'success');
        await fetchRentas();
      } catch (error) {
        console.error('Error al eliminar cliente:', error);
        Swal.fire('Error', 'No se pudo eliminar el cliente', 'error');
      }
    }
  };

  const closeModal = () => {
    setIsEditModalOpen(false);
    setEditingCliente(null);
  };

  const handleActualizarEmpresaSII = async (renta) => {
    const clienteId = renta.clienteId?._id;
    if (!clienteId) return;
    setActualizandoSII(prev => ({ ...prev, [clienteId]: true }));
    try {
      await api.post(`/estados-sii/actualizar-empresa/${clienteId}`, { año: selectedYear });
      toast.success(`Consulta completada para ${renta.clienteId?.nombre}. Datos actualizados.`);
      fetchEstadosSII();
    } catch (err) {
      toast.error(err.response?.data?.error || 'Error al actualizar empresa');
    } finally {
      setActualizandoSII(prev => ({ ...prev, [clienteId]: false }));
    }
  };
  
  
  const handleReprocesarApertura = async () => {
    const { value: confirmed } = await Swal.fire({
      title: `Reprocesar apertura ${selectedYear}`,
      text: 'Se agregarán nuevos clientes con renta activa que no estén en el listado',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, procesar',
      cancelButtonText: 'Cancelar'
    });
  
    if (confirmed) {
      try {
        console.log('Reprocesando apertura para año:', selectedYear);
        setLoading(true);
        
        const response = await api.post(`${process.env.REACT_APP_API_URL}/rentas/reprocesar/${selectedYear}`, {
          contadorId: currentUser.id
        });
        
        console.log('Respuesta de reproceso:', response.data);
  
        if (response.data.errores && response.data.errores.length > 0) {
          Swal.fire({
            title: 'Apertura completada con advertencias',
            html: `
              Registros creados: ${response.data.registrosCreados}<br>
              Sin cambios: ${response.data.sinCambios}<br>
              Errores: ${response.data.errores.length}<br>
              ${response.data.errores.map(e => `- ${e.cliente}: ${e.error}`).join('<br>')}
            `,
            icon: 'warning'
          });
        } else {
          Swal.fire('Éxito', `Apertura reprocesada: ${response.data.registrosCreados} nuevos registros creados.`, 'success');
        }
  
        fetchRentas();
      } catch (error) {
        console.error('Error en reproceso:', error);
        Swal.fire('Error', 'No se pudo reprocesar la apertura: ' + (error.response?.data?.error || error.message), 'error');
      } finally {
        setLoading(false);
      }
    }
  };


  const handleDownloadPDF = async () => {
    try {
        console.log("Iniciando descarga de PDF...");
        setLoading(true);
        
        // Mostrar un mensaje de carga cuando hay muchos registros
        let loadingMessage;
        if (!search && !selectedEstado && !selectedContador) {
            loadingMessage = Swal.fire({
                title: 'Generando PDF',
                html: 'Procesando todos los registros. Esto puede tomar hasta un minuto...',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });
        }
        
        // Parámetros para la petición incluyendo DJ
        const params = {
            año: selectedYear,
            contador: selectedContador,
            estado: selectedEstado,
            search: search,
            dj: selectedDJ // Agregar filtro DJ
        };
        
        // Configuración avanzada para la petición
        const config = {
            params,
            timeout: 120000, // 2 minutos para peticiones grandes
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Content-Type': 'application/json'
            },
            // Evitar caché
            cache: false
        };
        
        // Hacer la petición
        const response = await api.get(`${process.env.REACT_APP_API_URL}/rentas/all`, config);
        
        // Cerrar mensaje de carga si existe
        if (loadingMessage) {
            loadingMessage.close();
        }
        
        const allRentas = response.data.rentas || [];
        console.log(`Obtenidas ${allRentas.length} rentas para el PDF`);
        
        if (allRentas.length === 0) {
            Swal.fire('Información', 'No hay datos para generar el PDF', 'info');
            setLoading(false);
            return;
        }
        
        try {
            // Crear el PDF con todos los registros
            const doc = new jsPDF('landscape');
            doc.text(`Listado de Renta - Año ${selectedYear}`, 14, 15);
            
            // Añadir filtros aplicados (corregir lógica DJ)
            let filtersText = 'Filtros: ';
            if (selectedContador) filtersText += `Contador: ${selectedContador}, `;
            if (selectedEstado) filtersText += `Estado: ${selectedEstado}, `;
            if (selectedDJ === 'true') filtersText += `DJ: Con DJ, `;
            if (search) filtersText += `Búsqueda: ${search}, `;
            filtersText = filtersText.endsWith(', ') ? filtersText.slice(0, -2) : filtersText;
            if (filtersText === 'Filtros: ') filtersText += 'Todos los registros';
            
            doc.setFontSize(10);
            doc.text(filtersText, 14, 22);
            
            // Generar tabla con todos los datos incluyendo DJ
            autoTable(doc, {
                startY: 28,
                head: [['Cliente', 'RUT', 'Clave', 'Estado', 'DJ', 'Banco', 'Cuenta', 'Contador']],
                body: allRentas.map((renta) => [
                    renta.clienteId?.nombre || '',
                    formatRut(renta.clienteId?.rut) || '',
                    renta.clienteId?.clave || '',
                    renta.estado,
                    renta.dj ? 'Sí' : 'No', // Mostrar DJ como Sí/No
                    renta.clienteId?.banco || '',
                    renta.clienteId?.cuenta || '',
                    renta.contador || 'No asignado'
                ]),
                theme: 'grid',
                styles: { fontSize: 8, cellPadding: 2 },
                headStyles: { fillColor: [59, 130, 246], textColor: [255, 255, 255] },
                alternateRowStyles: { fillColor: [240, 240, 240] }
            });
            
            // Añadir paginación
            const pageCount = doc.getNumberOfPages();
            for (let i = 1; i <= pageCount; i++) {
                doc.setPage(i);
                doc.setFontSize(8);
                doc.text(
                    `Página ${i} de ${pageCount} - Generado el ${new Date().toLocaleString()}`,
                    doc.internal.pageSize.getWidth() / 2,
                    doc.internal.pageSize.getHeight() - 10,
                    { align: 'center' }
                );
            }
            
            console.log("Guardando PDF...");
            doc.save(`Listado_Renta_${selectedYear}.pdf`);
            console.log("PDF generado correctamente");
        } catch (pdfError) {
            console.error("Error generando PDF:", pdfError);
            Swal.fire('Error', `Error al generar el PDF: ${pdfError.message}`, 'error');
        }
        
        setLoading(false);
    } catch (error) {
        console.error("Error al obtener datos para PDF:", error);
        
        // Mensaje más específico según el tipo de error
        let errorMessage;
        if (error.code === 'ERR_NETWORK') {
            errorMessage = 'La petición tomó demasiado tiempo. Intenta con menos datos usando filtros.';
        } else if (error.response && error.response.status === 413) {
            errorMessage = 'La cantidad de datos es demasiado grande. Intenta aplicar más filtros.';
        } else {
            errorMessage = `No se pudo generar el PDF: ${error.message}`;
        }
        
        Swal.fire('Error', errorMessage, 'error');
        setLoading(false);
    }
};


    // Cargar contadores (usuarios con rol CONTADOR)
    useEffect(() => {
        const fetchContadores = async () => {
            try {
                const response = await api.get(`${process.env.REACT_APP_API_URL}/rentas/contadores`);
                setContadores(response.data || []); // Si viene null o undefined, usar array vacío
            } catch (error) {
                console.error('Error al cargar contadores:', error);
                setContadores([]); // En caso de error, inicializar como vacío
            }
        };
        fetchContadores();
    }, []);

    // Cargar datos de renta con filtros incluyendo DJ
    const fetchRentas = async () => {
        try {
            setLoading(true);

            const currentYear = selectedYear;
            const currentContador = selectedContador;
            const currentEstado = selectedEstado;
            const currentDJ = selectedDJ; // Incluir filtro DJ
            const currentPage = page;
            const currentSearch = search;

            const response = await api.get(`${process.env.REACT_APP_API_URL}/rentas`, {
                params: {
                    page: currentPage,
                    search: currentSearch,
                    año: currentYear,
                    contador: currentContador,
                    estado: currentEstado,
                    dj: currentDJ // Agregar parámetro DJ
                }
            });

            if (!response.data.rentas?.length) {
                setRentas([]);
                setFilteredRentas([]);
                setTotalPages(0);
                return;
            }

            setRentas(response.data.rentas);
            setFilteredRentas(response.data.rentas);
            setTotalPages(response.data.totalPages);
        } catch (error) {
            console.error('Error al cargar rentas:', error);
            setRentas([]);
            setFilteredRentas([]);
            setTotalPages(0);
        } finally {
            setLoading(false);
        }
    };

    const fetchEstadosSII = async () => {
        try {
            const response = await api.get(`/estados-sii/${selectedYear}`);
            
            // Crear un mapa de RUT -> datos completos del año seleccionado
            const estadosMap = {};
            response.data.forEach(cliente => {
                const añoEstado = cliente.estados?.find(e => e.año === selectedYear);
                if (añoEstado) {
                    const estadoInfo = estadosSIIMap[añoEstado.estado] || estadosSIIMap.no_declarada;
                    estadosMap[cliente.rut] = {
                        ...estadoInfo,
                        estado: añoEstado.estado,
                        mensajeSituacion: añoEstado.mensajeSituacion || '',
                        historial: añoEstado.historial || [],
                        ultimoEvento: añoEstado.ultimoEvento || null,
                        fechaConsulta: añoEstado.fechaConsulta || null,
                        nombre: cliente.nombre
                    };
                }
            });
            
            setEstadosSII(estadosMap);
        } catch (error) {
            console.error('Error al cargar estados SII:', error);
            setEstadosSII({});
        }
    };

    useEffect(() => {
        fetchRentas();
        fetchEstadosSII(); // Cargar estados SII en paralelo
    }, [page, selectedYear, selectedContador, selectedEstado, selectedDJ]); // Agregar selectedDJ a las dependencias

    // Apertura de nuevo año
    const handleApertura = async () => {
        const { value: confirmed } = await Swal.fire({
            title: `¿Crear listado para ${selectedYear}?`,
            text: 'Se crearán registros para todos los clientes con renta activa',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sí, crear',
            cancelButtonText: 'Cancelar'
        });

        if (confirmed) {
            try {
                console.log('Intentando apertura para año:', selectedYear);
                const response = await axios.post(`${process.env.REACT_APP_API_URL}/rentas/apertura/${selectedYear}`, {
                    contadorId: currentUser.id
                });
                console.log('Respuesta de apertura:', response.data);

                if (response.data.errores && response.data.errores.length > 0) {
                    Swal.fire({
                        title: 'Apertura completada con advertencias',
                        html: `
                            Registros creados: ${response.data.registrosCreados}<br>
                            Errores: ${response.data.errores.length}<br>
                            ${response.data.errores.map(e => `- ${e.cliente}: ${e.error}`).join('<br>')}
                        `,
                        icon: 'warning'
                    });
                } else {
                    Swal.fire('Éxito', response.data.mensaje, 'success');
                }

                fetchRentas();
            } catch (error) {
                console.error('Error en apertura:', error);
                Swal.fire('Error', 'No se pudo crear el listado: ' + (error.response?.data?.error || error.message), 'error');
            }
        }
    };


    // Agregar función para limpiar la selección al hacer clic fuera de la tabla
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('table')) {
                setSelectedRow(null);
            }
        };

        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);


    // Agregar esta función
    const handleInputChange = (field, value, rentaId) => {
        setEditingValue({ field, value, rentaId });
    };

    const handleInputBlur = async (rentaId) => {
        if (editingValue && editingValue.rentaId === rentaId) {
            await handleUpdate(rentaId, editingValue.field, editingValue.value);
            setEditingValue(null);
        }
    };

    const handleUpdate = async (id, field, value) => {
        try {
            const data = {};

            // Campos numéricos de renta
            if (['devolucion', 'pagada', 'pendientePago', 'diferida'].includes(field)) {
                if (value === '' || value === null || value === undefined) {
                    // Si está vacío, enviar null para que la BD no guarde nada
                    data[field] = null;
                } else {
                    const numValue = parseInt(value.replace(/[^0-9-]/g, ''));
                    if (!isNaN(numValue)) {
                        data[field] = numValue;
                    } else {
                        return;
                    }
                }
            }
            // Campos del cliente
            else if (['banco', 'cuenta', 'clave'].includes(field)) {
                data[field] = value;
            }
            // Otros campos de renta
            else {
                data[field] = value;
            }

            const response = await api.put(`/rentas/${id}`, data);

            setFilteredRentas(prev =>
                prev.map(renta =>
                    renta._id === id ? {
                        ...renta,
                        ...response.data,
                        clienteId: {
                            ...renta.clienteId,
                            banco: response.data.clienteId?.banco,
                            cuenta: response.data.clienteId?.cuenta,
                            clave: response.data.clienteId?.clave
                        }
                    } : renta
                )
            );


        } catch (error) {
            console.error('Error al actualizar:', error);
            Swal.fire('Error', 'No se pudo actualizar el registro', 'error');
        }
    };

    // Búsqueda actualizada para incluir filtro DJ
    const handleSearch = useCallback(
        debounce(async (searchTerm) => {
            setLoading(true);
            try {
                const response = await api.get(
                    `${process.env.REACT_APP_API_URL}/rentas`,
                    {
                        params: {
                            page: 1,
                            search: searchTerm,
                            año: selectedYear,
                            contador: selectedContador,
                            estado: selectedEstado,
                            dj: selectedDJ // Incluir filtro DJ
                        }
                    }
                );
                setFilteredRentas(response.data.rentas);
                setTotalPages(response.data.totalPages);
                setPage(1);
            } catch (error) {
                console.error('Error en búsqueda:', error);
            } finally {
                setLoading(false);
            }
        }, 300),
        [selectedYear, selectedContador, selectedEstado, selectedDJ] // Agregar selectedDJ
    );

    // Manejar cambios en el input de búsqueda
    const handleSearchInput = (e) => {
        const value = e.target.value;
        setSearch(value);
        
        // Solo normalizar como RUT si contiene guión, sino enviar tal cual (con espacios para búsqueda de nombres)
        const searchValue = value.includes('-') ? normalizeRut(value) : value.trim();
        handleSearch(searchValue);

        // Si el input está vacío, recargar datos originales
        if (!value.trim()) {
            fetchRentas();
        }
    };



    useEffect(() => {
        // procesar la URL cada vez
        const params = new URLSearchParams(location.search);
        const añoParam = params.get('año');
        const estadoParam = params.get('estado');
        const contadorParam = params.get('contador');
        const djParam = params.get('dj'); // Agregar parámetro DJ

        // actualiza estados (sin comparar para no bloquear el refresh)
        if (añoParam && !isNaN(+añoParam)) {
            setSelectedYear(+añoParam);
        } else {
            // si no hay param de año, opcionalmente mantener o resetear
            setSelectedYear(new Date().getFullYear());
        }
        setSelectedEstado(estadoParam || '');
        setSelectedContador(contadorParam || '');
        setSelectedDJ(djParam || ''); // Establecer filtro DJ

        // dispara fetch con los valores recién seteados
        // usar un pequeño timeout o un nextTick
        setTimeout(() => fetchRentas(), 0);

    }, [location.search]);


    return (
        <div className="container mx-auto px-1">
            <div className="bg-white rounded-lg shadow-lg p-2">
                <div className="flex justify-between items-center mb-1">
                    <h1 className="text-xl font-bold text-gray-800">Listado Renta {selectedYear}</h1>
                    <button
                        onClick={async () => {
                            const { value: año } = await Swal.fire({
                                title: 'Apertura de Nuevo Año',
                                html: `
                    <div class="mb-4">
                        <p class="text-sm text-gray-600 mb-2">
                            Seleccione el año para el cual desea crear los registros de renta
                        </p>
                        <select id="yearSelect" class="w-full p-2 border rounded">
                            ${Array.from({ length: 3 }, (_, i) => {
                                    const year = new Date().getFullYear() + i;
                                    return `<option value="${year}">${year}</option>`;
                                }).join('')}
                        </select>
                    </div>
                `,
                                showCancelButton: true,
                                confirmButtonText: 'Crear Registros',
                                cancelButtonText: 'Cancelar',
                                preConfirm: () => {
                                    return document.getElementById('yearSelect').value;
                                }
                            });

                            if (año) {
                                const { value: confirmed } = await Swal.fire({
                                    title: `¿Crear registros para ${año}?`,
                                    html: `
                        <div class="text-left">
                            <p class="text-sm text-gray-600 mb-2">Esta acción:</p>
                            <ul class="list-disc pl-5 text-sm text-gray-600">
                                <li>Creará registros para todos los clientes con renta activa</li>
                                <li>Si ya existen registros para ${año}, se mantendrán sin cambios</li>
                                <li>Los nuevos registros se crearán en estado 'pendiente'</li>
                            </ul>
                        </div>
                    `,
                                    icon: 'question',
                                    showCancelButton: true,
                                    confirmButtonText: 'Sí, crear',
                                    cancelButtonText: 'Cancelar'
                                });

                                if (confirmed) {
                                    try {
                                        const response = await axios.post(
                                            `${process.env.REACT_APP_API_URL}/rentas/apertura/${año}`,
                                            { contadorId: currentUser.id }
                                        );

                                        if (response.data.errores?.length > 0) {
                                            Swal.fire({
                                                title: 'Apertura completada con advertencias',
                                                html: `
                                    <div class="text-left">
                                        <p>Registros creados: ${response.data.registrosCreados}</p>
                                        <p>Errores: ${response.data.errores.length}</p>
                                        <div class="mt-2">
                                            ${response.data.errores.map(e =>
                                                    `<p class="text-sm text-red-600">- ${e.cliente}: ${e.error}</p>`
                                                ).join('')}
                                        </div>
                                    </div>
                                `,
                                                icon: 'warning'
                                            });
                                        } else {
                                            Swal.fire('Éxito', response.data.mensaje, 'success');
                                        }

                                        // Actualizar el año seleccionado y recargar datos
                                        setSelectedYear(Number(año));
                                        await fetchRentas();
                                    } catch (error) {
                                        console.error('Error en apertura:', error);
                                        Swal.fire('Error',
                                            'No se pudo crear el listado: ' +
                                            (error.response?.data?.error || error.message),
                                            'error'
                                        );
                                    }
                                }
                            }
                        }}
                        className="bg-blue-600 text-white px-4 py-1 rounded-md text-sm shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-1 focus:ring-blue-500 transition-colors flex items-center"
                    >
                        <FontAwesomeIcon icon={faSync} className="mr-1" />
                        Nueva Apertura
                    </button>
                    <button
    onClick={handleReprocesarApertura}
    className="bg-purple-500 text-white px-4 py-2 rounded hover:bg-purple-600"
    disabled={loading}
  >
    Reprocesar Apertura
  </button>
                </div>

                {/* Filtros mejorados */}
                <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-2">
                    <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">Año</label>
                        <select
                            value={selectedYear}
                            onChange={(e) => setSelectedYear(Number(e.target.value))}
                            className="w-full p-3 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        >
                            {years.map((year) => (
                                <option key={year} value={year}>{year}</option>
                            ))}
                        </select>
                    </div>

                    <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">Asignado</label>
                        <select
                            value={selectedContador}
                            onChange={(e) => setSelectedContador(e.target.value)}
                            className="w-full p-3 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        >
                            <option value="">Todos</option>
                            <option value="no-asignado">No asignado</option>
                            {contadores.map((contador) => (
                                <option key={contador} value={contador}>{contador}</option>
                            ))}
                        </select>
                    </div>

                    <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">Estado</label>
                        <select
                            value={selectedEstado}
                            onChange={(e) => setSelectedEstado(e.target.value)}
                            className="w-full p-3 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        >
                            <option value="">Todos</option>
                            {estados.map((estado) => (
                                <option key={estado} value={estado}>{estado}</option>
                            ))}
                        </select>
                    </div>

                    {/* Filtro DJ simplificado */}
                    <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">Declaración Jurada</label>
                        <select
                            value={selectedDJ}
                            onChange={(e) => setSelectedDJ(e.target.value)}
                            className="w-full p-3 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        >
                            <option value="">Todos</option>
                            <option value="true">Con DJ</option>
                        </select>
                    </div>

                    <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">Buscar</label>
                        <div className="relative">
                            <input
                                type="text"
                                value={search}
                                onChange={handleSearchInput}
                                placeholder="Buscar por nombre o RUT..."
                                className="w-full p-2 pl-8 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            />
                            <FontAwesomeIcon icon={faSearch} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                        </div>
                    </div>
                </div>

                

                {/* Resumen de estados */}
                <div className="mb-2 no-print flex justify-between items-center">
                    <div>
                    <h3 className="text-sm font-medium text-gray-700 mb-2">Estados:</h3>
                    <div className="flex flex-wrap gap-4">
                        {estados.map((estado) => (
                            <div key={estado} className="flex items-center">
                                <div className={`w-6 h-6 rounded border ${estadosConfig[estado].color} ${estadosConfig[estado].border}`}></div>
                                <span className="ml-2 text-sm text-gray-600">{estado}</span>
                            </div>
                        ))}
                    </div>
                </div>
                <button
        onClick={handleDownloadPDF}
        className="bg-blue-600 text-white px-4 py-2 rounded-md text-sm shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-1 focus:ring-blue-500 transition-colors"
    >
        Descargar PDF
    </button>

    <button
    onClick={() => setShowCreateForm(!showCreateForm)}
    className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
  >
    Nuevo Cliente
  </button>

    </div>




{/* Formulario de creación */}
{showCreateForm && (
  <div className="bg-white shadow rounded p-4 mb-6">
    <h2 className="text-xl font-semibold mb-4">Crear Nuevo Cliente</h2>
    <form onSubmit={handleCreateSubmit} className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium mb-1">Apellido Nombre o Razon Social</label>
          <input
            type="text"
            value={newCliente.nombre}
            onChange={(e) => setNewCliente({ ...newCliente, nombre: e.target.value })}
            className="w-full border p-2 rounded"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">RUT</label>
          <input
            type="text"
            value={newCliente.rut}
            onChange={(e) => setNewCliente({ ...newCliente, rut: e.target.value })}
            className="w-full border p-2 rounded"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Clave</label>
          <input
            type="text"
            value={newCliente.clave}
            onChange={(e) => setNewCliente({ ...newCliente, clave: e.target.value })}
            className="w-full border p-2 rounded"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Banco</label>
          <input
            type="text"
            value={newCliente.banco}
            onChange={(e) => setNewCliente({ ...newCliente, banco: e.target.value })}
            className="w-full border p-2 rounded"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Cuenta</label>
          <input
            type="text"
            value={newCliente.cuenta}
            onChange={(e) => setNewCliente({ ...newCliente, cuenta: e.target.value })}
            className="w-full border p-2 rounded"
          />
        </div>
      </div>
      <div className="flex space-x-4">
        <label className="flex items-center">
          <input
            type="checkbox"
            checked={newCliente.iva}
            onChange={(e) => setNewCliente({ ...newCliente, iva: e.target.checked })}
            className="mr-2"
          />
          IVA
        </label>
        <label className="flex items-center">
          <input
            type="checkbox"
            checked={newCliente.renta}
            onChange={(e) => setNewCliente({ ...newCliente, renta: e.target.checked })}
            className="mr-2"
          />
          Renta
        </label>
        <label className="flex items-center">
          <input
            type="checkbox"
            checked={newCliente.arriendo}
            onChange={(e) => setNewCliente({ ...newCliente, arriendo: e.target.checked })}
            className="mr-2"
          />
          Arriendo
        </label>
      </div>
      <div className="flex justify-end space-x-2">
        <button
          type="button"
          onClick={() => setShowCreateForm(false)}
          className="px-4 py-2 border rounded"
        >
          Cancelar
        </button>
        <button
          type="submit"
          className="px-4 py-2 bg-blue-500 text-white rounded"
        >
          Guardar
        </button>
      </div>
    </form>
  </div>
)}




                

                {/* Tabla mejorada */}
                {/* <div ref={printRef} className="print-content">
                <h2 className="text-xl font-bold text-center mb-4 print-only">Listado de Renta - Año {selectedYear}</h2> */}
                <div className="table-container">
                    {loading ? (
                        <div className="text-center py-4">Cargando...</div>
                    ) : filteredRentas.length === 0 ? (
                        <div className="text-center py-4 text-gray-500">
                            No hay registros disponibles.
                            {!years.length && " Realice una apertura para comenzar."}
                        </div>
                    ) : (
                        
                        <div className="table-wrapper">
                            
                            <table className="data-table">
                                <thead className="bg-gray-50">
                                    <tr>
                                        <th className="w-10 px-2 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" title="Estado SII">SII</th>
                                        <th className="w-28 px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cliente</th>
                                        <th className="w-28 px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">RUT</th>
                                        <th className="w-28 px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Clave</th>
                                        <th className="w-32 px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Estado</th>
                                        {/* Nueva columna para DJ */}
                                        <th className="w-20 px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">DJ</th>
                                        <th className="w-36 px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Devolución</th>
                                        <th className="w-36 px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Pagada</th>
                                        <th className="w-36 px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Pendiente</th>
                                        <th className="w-36 px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Diferida</th>
                                        <th className="w-40 px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Observaciones</th>
                                        <th className="w-32 px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Asignado</th>
                                        <th className="w-28 px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Banco</th>
                                        <th className="w-28 px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cuenta</th>
                                        <th className="w-24 px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Acciones</th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                    {filteredRentas.map((renta) => (
                                        <tr key={renta._id}
                                            className={`transition-all ${estadosConfig[renta.estado].row} ${selectedRow === renta._id ? 'ring-2 ring-blue-500 ring-inset' : ''} hover:brightness-95 hover:shadow-inner`}
                                            onClick={() => setSelectedRow(renta._id)}>
                                            {/* Estado SII — clickeable para ver detalle + botón actualizar */}
                                            <td className="px-2 py-2 text-center">
                                                <div className="flex items-center justify-center gap-1">
                                                    <button
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            const data = estadosSII[renta.clienteId?.rut];
                                                            if (data) setSiiModal({ nombre: renta.clienteId?.nombre, rut: renta.clienteId?.rut, data });
                                                        }}
                                                        title={estadosSII[renta.clienteId?.rut]?.title || 'Sin datos SII — haz clic para ver'}
                                                        className="hover:scale-125 transition-transform cursor-pointer leading-none text-lg"
                                                    >
                                                        {estadosSII[renta.clienteId?.rut]?.icon || '•'}
                                                    </button>
                                                    <button
                                                        onClick={(e) => { e.stopPropagation(); handleActualizarEmpresaSII(renta); }}
                                                        disabled={actualizandoSII[renta.clienteId?._id]}
                                                        className="text-emerald-500 hover:text-emerald-700 transition-colors disabled:opacity-40"
                                                        title="Actualizar estado SII ahora"
                                                    >
                                                        {actualizandoSII[renta.clienteId?._id] ? (
                                                            <svg className="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none">
                                                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
                                                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
                                                            </svg>
                                                        ) : (
                                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                                                <path fillRule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clipRule="evenodd" />
                                                            </svg>
                                                        )}
                                                    </button>
                                                </div>
                                            </td>
                                            {/* ...existing cells... */}
                                            <td className="px-3 py-2 whitespace-nowrap text-sm">
                                                {renta.clienteId?.nombre?.substring(0, 50)}
                                                {renta.clienteId?.nombre?.length > 50 ? '...' : ''}
                                            </td>
                                            <td className="px-3 py-2 whitespace-nowrap text-sm">{formatRut(renta.clienteId?.rut)}</td>
                                            <td className="px-3 py-2 whitespace-nowrap text-sm">
                                                <input
                                                    type="text"
                                                    value={editingValue?.field === 'clave' && editingValue.rentaId === renta._id
                                                        ? editingValue.value
                                                        : (renta.clienteId?.clave || '')}
                                                    onChange={(e) => handleInputChange('clave', e.target.value, renta._id)}
                                                    onBlur={() => handleInputBlur(renta._id)}
                                                    className="w-full p-1 text-sm border rounded min-w-[95px]"
                                                />
                                            </td>
                                            <td className="px-3 py-2">
                                                <select
                                                    value={renta.estado}
                                                    onChange={(e) => handleUpdate(renta._id, 'estado', e.target.value)}
                                                    className={`w-full p-1 text-sm border rounded min-w-[90px] ${estadosConfig[renta.estado].color} ${estadosConfig[renta.estado].text}`}
                                                >
                                                    {estados.map((estado) => (
                                                        <option
                                                            key={estado}
                                                            value={estado}
                                                            className={`${estadosConfig[estado].color} ${estadosConfig[estado].text}`}
                                                        >
                                                            {estado}
                                                        </option>
                                                    ))}
                                                </select>
                                            </td>
                                            {/* Nueva celda para checkbox DJ */}
                                            <td className="px-3 py-2 text-center">
                                                <input
                                                    type="checkbox"
                                                    checked={renta.dj || false}
                                                    onChange={(e) => handleUpdate(renta._id, 'dj', e.target.checked)}
                                                    className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                                />
                                            </td>
                                            {/* ...existing numeric fields... */}
                                            {['devolucion', 'pagada', 'pendientePago', 'diferida'].map((field) => (
                                                <td key={field} className="px-3 py-2">
                                                    <input
                                                        type="text"
                                                        value={editingValue?.field === field && editingValue.rentaId === renta._id
                                                            ? editingValue.value
                                                            : (renta[field] ?? '')}
                                                        onChange={(e) => handleInputChange(field, e.target.value, renta._id)}
                                                        onBlur={() => handleInputBlur(renta._id)}
                                                        className="w-full p-1 text-sm border rounded text-right min-w-[95px]"
                                                        style={{ WebkitAppearance: 'none', MozAppearance: 'textfield' }}
                                                    />
                                                </td>
                                            ))}
                                            {/* ...existing cells for observaciones, asignado, banco, cuenta... */}
                                            <td className="px-3 py-2">
                                                <input
                                                    type="text"
                                                    value={editingValue?.field === 'observaciones' && editingValue.rentaId === renta._id
                                                        ? editingValue.value
                                                        : (renta.observaciones || '')}
                                                    onChange={(e) => handleInputChange('observaciones', e.target.value, renta._id)}
                                                    onBlur={() => handleInputBlur(renta._id)}
                                                    className="w-full p-1 text-sm border rounded"
                                                />
                                            </td>
                                            <td className="px-3 py-2">
                                                <select
                                                    value={renta.contador || ''}
                                                    onChange={(e) => {
                                                        const valor = e.target.value === 'no-asignado' ? '' : e.target.value;
                                                        handleUpdate(renta._id, 'contador', valor);
                                                    }}
                                                    className="w-full p-1 text-sm border rounded min-w-[90px]"
                                                >
                                                    <option value="">No asignado</option>
                                                    {contadores.map((contador) => (
                                                        <option key={contador} value={contador}>{contador}</option>
                                                    ))}
                                                </select>
                                            </td>
                                            <td className="px-3 py-2">
                                                <input
                                                    type="text"
                                                    value={editingValue?.field === 'banco' && editingValue.rentaId === renta._id
                                                        ? editingValue.value
                                                        : (renta.clienteId?.banco || '')}
                                                    onChange={(e) => handleInputChange('banco', e.target.value, renta._id)}
                                                    onBlur={() => handleInputBlur(renta._id)}
                                                    className="w-full p-1 text-sm border rounded min-w-[150px]"
                                                />
                                            </td>
                                            <td className="px-3 py-2">
                                                <input
                                                    type="text"
                                                    value={editingValue?.field === 'cuenta' && editingValue.rentaId === renta._id
                                                        ? editingValue.value
                                                        : (renta.clienteId?.cuenta || '')}
                                                    onChange={(e) => handleInputChange('cuenta', e.target.value, renta._id)}
                                                    onBlur={() => handleInputBlur(renta._id)}
                                                    className="w-full p-1 text-sm border rounded min-w-[140px]"
                                                />
                                            </td>
                                            <td className="px-3 py-2 text-center">
                                                <div className="flex justify-center gap-2">
                                                    <button
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleEditClick(renta);
                                                        }}
                                                        className="text-blue-600 hover:text-blue-800 transition-colors p-1"
                                                        title="Editar cliente"
                                                    >
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                                            <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                                                        </svg>
                                                    </button>
                                                    <button
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleDelete(renta);
                                                        }}
                                                        className="text-red-600 hover:text-red-800 transition-colors p-1"
                                                        title="Eliminar cliente"
                                                    >
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                                            <path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
                                                        </svg>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
                </div>
                

                {/* Paginación mejorada */}
                {
                    filteredRentas.length > 0 && (
                        <div className="flex justify-center items-center gap-2 mt-6 no-print">
                            <button
                                onClick={() => setPage(1)}
                                disabled={page === 1}
                                className="px-3 py-1 border border-gray-300 rounded-md text-sm bg-white hover:bg-gray-50 disabled:opacity-50"
                            >
                                {'<<'}
                            </button>
                            <button
                                onClick={() => setPage(p => Math.max(1, p - 1))}
                                disabled={page === 1}
                                className="px-3 py-1 border border-gray-300 rounded-md text-sm bg-white hover:bg-gray-50 disabled:opacity-50"
                            >
                                {'<'}
                            </button>

                            <div className="flex gap-1">
                                {[...Array(totalPages)].map((_, i) => {
                                    const pageNum = i + 1;
                                    // Mostrar siempre primera, última, actual y 1 página antes y después
                                    if (
                                        pageNum === 1 ||
                                        pageNum === totalPages ||
                                        (pageNum >= page - 1 && pageNum <= page + 1) ||
                                        (pageNum === page - 2 && page > 3) ||
                                        (pageNum === page + 2 && page < totalPages - 2)
                                    ) {
                                        return (
                                            <button
                                                key={pageNum}
                                                onClick={() => setPage(pageNum)}
                                                className={`px-3 py-1 border rounded-md text-sm ${page === pageNum
                                                    ? 'bg-blue-500 text-white border-blue-500'
                                                    : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
                                                    }`}
                                            >
                                                {pageNum}
                                            </button>
                                        );
                                    } else if (
                                        (pageNum === page - 3 && page > 4) ||
                                        (pageNum === page + 3 && page < totalPages - 3)
                                    ) {
                                        return <span key={pageNum} className="px-2">...</span>;
                                    }
                                    return null;
                                })}
                            </div>

                            <button
                                onClick={() => setPage(p => Math.min(totalPages, p + 1))}
                                disabled={page === totalPages}
                                className="px-3 py-1 border border-gray-300 rounded-md text-sm bg-white hover:bg-gray-50 disabled:opacity-50"
                            >
                                {'>'}
                            </button>
                            <button
                                onClick={() => setPage(totalPages)}
                                disabled={page === totalPages}
                                className="px-3 py-1 border border-gray-300 rounded-md text-sm bg-white hover:bg-gray-50 disabled:opacity-50"
                            >
                                {'>>'}
                            </button>
                        </div>
                    )
                }

            {/* Modal detalle SII */}
            <ReactModal
                isOpen={!!siiModal}
                onRequestClose={() => setSiiModal(null)}
                contentLabel="Detalle Estado SII"
                className="max-w-2xl mx-auto mt-16 bg-white rounded-xl shadow-2xl p-6 outline-none"
                overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex items-start justify-center pt-10 z-50"
            >
                {siiModal && (() => {
                    const d = siiModal.data;
                    const estadoInfo = estadosSIIMap[d.estado] || estadosSIIMap.no_declarada;
                    return (
                        <div>
                            <div className="flex justify-between items-start mb-4">
                                <div>
                                    <h2 className="text-lg font-bold text-gray-800">{siiModal.nombre}</h2>
                                    <p className="text-sm text-gray-500">{siiModal.rut} · Año {selectedYear}</p>
                                </div>
                                <button onClick={() => setSiiModal(null)} className="text-gray-400 hover:text-gray-600 text-2xl leading-none">&times;</button>
                            </div>

                            {/* Estado principal */}
                            <div className="flex items-center gap-3 bg-gray-50 rounded-lg p-4 mb-4">
                                <span className="text-4xl">{estadoInfo.icon}</span>
                                <div>
                                    <p className="font-semibold text-gray-800">{estadoInfo.title}</p>
                                    {d.fechaConsulta && (
                                        <p className="text-xs text-gray-400">
                                            Consultado: {new Date(d.fechaConsulta).toLocaleString('es-CL')}
                                        </p>
                                    )}
                                </div>
                            </div>

                            {/* Situación */}
                            {d.mensajeSituacion && (
                                <div className="mb-4">
                                    <p className="text-xs font-semibold text-gray-500 uppercase mb-1">Situación:</p>
                                    <p className="text-sm text-gray-700 bg-blue-50 rounded p-3">{d.mensajeSituacion}</p>
                                </div>
                            )}

                            {/* Último evento */}
                            {d.ultimoEvento && (
                                <div className="mb-4">
                                    <p className="text-xs font-semibold text-gray-500 uppercase mb-1">Último Evento:</p>
                                    <div className="flex gap-3 text-sm bg-gray-50 rounded p-3">
                                        <span className="text-gray-400 whitespace-nowrap">{d.ultimoEvento.fecha}</span>
                                        <span className="text-gray-800">{d.ultimoEvento.descripcion}</span>
                                    </div>
                                </div>
                            )}

                            {/* Historial */}
                            {d.historial?.length > 0 && (
                                <div>
                                    <p className="text-xs font-semibold text-gray-500 uppercase mb-2">Historial completo:</p>
                                    <table className="w-full text-sm">
                                        <thead>
                                            <tr className="bg-gray-100">
                                                <th className="text-left px-3 py-1 text-xs text-gray-500">Fecha</th>
                                                <th className="text-left px-3 py-1 text-xs text-gray-500">Descripción</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {d.historial.map((ev, i) => (
                                                <tr key={i} className={i % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                                                    <td className="px-3 py-1 whitespace-nowrap text-gray-400">{ev.fecha}</td>
                                                    <td className="px-3 py-1 text-gray-700">{ev.descripcion}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}

                            {(!d.historial?.length && !d.mensajeSituacion) && (
                                <p className="text-sm text-gray-400 text-center py-4">Sin datos disponibles para este año.</p>
                            )}
                        </div>
                    );
                })()}
            </ReactModal>

            {/* Modal de edición */}
            <ReactModal
                isOpen={isEditModalOpen}
                onRequestClose={closeModal}
                contentLabel="Editar Cliente"
                className="max-w-5xl mx-auto mt-20 bg-white rounded-lg shadow-xl p-6 outline-none"
                overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex items-start justify-center pt-10 z-50"
            >
                <div>
                    <h2 className="text-2xl font-bold mb-4">Editar Cliente</h2>
                    <form onSubmit={(e) => { e.preventDefault(); handleEditSave(); }}>
                        <div className="mb-4">
                            <label className="block text-sm font-medium text-gray-700 mb-1">Nombre</label>
                            <input
                                type="text"
                                name="nombre"
                                value={formData.nombre}
                                onChange={handleEditChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                required
                            />
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">RUT</label>
                                <input
                                    type="text"
                                    name="rut"
                                    value={formData.rut}
                                    onChange={handleEditChange}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    required
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Clave SII</label>
                                <input
                                    type="text"
                                    name="clave"
                                    value={formData.clave}
                                    onChange={handleEditChange}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Banco</label>
                                <input
                                    type="text"
                                    name="banco"
                                    value={formData.banco}
                                    onChange={handleEditChange}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Cuenta</label>
                                <input
                                    type="text"
                                    name="cuenta"
                                    value={formData.cuenta}
                                    onChange={handleEditChange}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                />
                            </div>
                        </div>
                        
                        <div className="mt-4">
                            <label className="block text-sm font-medium text-gray-700 mb-2">Categorías</label>
                            <div className="flex gap-4">
                                <label className="flex items-center">
                                    <input
                                        type="checkbox"
                                        name="iva"
                                        checked={formData.iva}
                                        onChange={handleEditChange}
                                        className="mr-2"
                                    />
                                    IVA
                                </label>
                                <label className="flex items-center">
                                    <input
                                        type="checkbox"
                                        name="renta"
                                        checked={formData.renta}
                                        onChange={handleEditChange}
                                        className="mr-2"
                                    />
                                    Renta
                                </label>
                                <label className="flex items-center">
                                    <input
                                        type="checkbox"
                                        name="arriendo"
                                        checked={formData.arriendo}
                                        onChange={handleEditChange}
                                        className="mr-2"
                                    />
                                    Arriendo
                                </label>
                            </div>
                        </div>

                        <div className="flex justify-end gap-3 mt-6">
                            <button
                                type="button"
                                onClick={closeModal}
                                className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors"
                            >
                                Cancelar
                            </button>
                            <button
                                type="submit"
                                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
                            >
                                Guardar Cambios
                            </button>
                        </div>
                    </form>
                </div>
            </ReactModal>
            </div >
        // </div >
    );
};

export default ListadoRenta;